var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternationalPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 6H14.8C12.149 6 10 8.14903 10 10.8V37.2C10 39.851 12.149 42 14.8 42H34C36.651 42 38.8 39.851 38.8 37.2V10.8C38.8 8.14903 36.651 6 34 6Z",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1707 18.5707L19.1082 22.6301L17.4914 21.0191L15.0941 21.8239C14.9344 21.8776 14.7904 21.9701 14.6753 22.0931C14.5601 22.2161 14.4772 22.3658 14.4342 22.5287C14.3911 22.6916 14.3892 22.8627 14.4286 23.0265C14.4679 23.1904 14.5474 23.3419 14.6597 23.4675L17.9055 27.0953C18.1712 27.3934 18.5189 27.6068 18.9051 27.7089C19.2913 27.811 19.699 27.7972 20.0774 27.6694L23.6299 26.475L22.9105 31.6066C22.8861 31.7784 22.906 31.9536 22.9685 32.1155C23.031 32.2774 23.1339 32.4206 23.2674 32.5315C23.4009 32.6424 23.5605 32.7172 23.7312 32.749C23.9018 32.7807 24.0777 32.7682 24.2421 32.7128L26.0897 32.0925C26.2311 32.0448 26.3604 31.9665 26.4683 31.8634C26.5762 31.7602 26.6601 31.6345 26.7141 31.4953L29.4155 24.5302L32.7929 23.3942C33.4326 23.1782 33.9604 22.717 34.26 22.112C34.5596 21.507 34.6066 20.8077 34.3906 20.1681C34.1746 19.5285 33.7133 19.0008 33.1081 18.7012C32.503 18.4017 31.8036 18.3547 31.1639 18.5707H31.1707Z",
    stroke: "#5F738C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.793 19.7053L24.0192 17.1076C23.8892 17.0177 23.74 16.9594 23.5835 16.9375C23.427 16.9156 23.2675 16.9306 23.1178 16.9814L21.3015 17.5907C21.1369 17.646 20.9892 17.7424 20.8724 17.8708C20.7555 17.9992 20.6735 18.1554 20.634 18.3245C20.5946 18.4935 20.599 18.6699 20.647 18.8367C20.6949 19.0036 20.7847 19.1554 20.9079 19.2778L22.9672 21.3271",
    stroke: "#5F738C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternationalPassport);
export default __webpack_public_path__ + "static/media/international_passport.77cee77f16dd4a415227e750f00fa8a5.svg";
export { ForwardRef as ReactComponent };